module.exports = __webpack_public_path__ + "static/media/Mayank.b5c582b6.jpg";